<template>
  <div class="chat-container" :key="discussion">
    <div class="chat-body" ref="chatBody" @scroll="spyScroll">
      <div class="d-flex justify-content-center" v-if="!loadedAll">
        <b-spinner/>
      </div>
      <div v-for="(m,i) in messages" :key="i" class="clearfix">
        <audio controls v-if="m.type === 1" :class="m.loc?'f-r':'f-l'">
          <source :src="m.message"/>
        </audio>
        <div :class="'chat-msg ' + (m.loc?'bg-primary f-r text-white':'bg-gray f-l')" v-else>
          {{ m.message }}
        </div>
      </div>
    </div>
    <div class="chat-footer">
      <b-textarea
          @keypress.enter="send"
          v-model="text"
          ref="textArea"
          :style="`height: calc(${1.5*lines}em + 0.75rem + 2px)`"
      />
      <!--      <b-button class="rounded-circle" variant="primary" @click="send">-->
      <!--        -->
      <!--      </b-button>-->
      <b-button class="rounded-circle" variant="primary" @click="send" v-if="text !== ''">
        <b-icon icon="arrow-right-short" scale="2.25"></b-icon>
      </b-button>
      <!--      <b-icon icon="arrow-right-circle-fill" variant="primary" scale="2.875" class="mr-1"></b-icon>-->
      <audio-record @audio="processAudio" :max-sec="1200" v-else v-visible="true"></audio-record>
    </div>
  </div>
</template>

<script>
import {Discussion} from "../js/caller";
import AudioRecord from "./audioRecord";
import Vue from "vue";

Vue.directive('visible', function(el, binding) {
  el.style.visibility = binding.value ? 'visible' : 'hidden';
});

const timeout = 3000;

function getTextWidth(text, font) {
  // re-use canvas object for better performance
  const canvas  = getTextWidth.canvas || (getTextWidth.canvas = document.createElement("canvas"));
  const context = canvas.getContext("2d");
  context.font  = font;
  const metrics = context.measureText(text);
  return metrics.width;
}

export default {
  name      : "chat",
  components: {AudioRecord},
  props     : {
    discussion: {type: String}
  },
  data() {
    return {
      timeOutID    : 0,
      messages     : [],
      discussion_id: "",
      //
      lines       : 1,
      text        : "",
      count       : 25,
      lockScroll  : true,
      updateScroll: true,
      loadedAll   : false,
    }
  },
  watch  : {
    text(newVal) {
      //TODO inquiry into space issue in computation lines P:Low
      const input = this.$refs.textArea.$refs.input;
      const style = getComputedStyle(input)
      const width = input.clientWidth - parseInt(style.paddingLeft.slice(0, -2)) - parseInt(style.paddingRight.slice(0, -2));
      const split = newVal.split("\n");
      this.lines  = Math.min(
          5,
          split.reduce((p, s) => p + 1 + Math.floor(getTextWidth(s.trimRight(), style.font) / width), 0)
      );
    },
  },
  methods: {
    async send($event) {
      if ($event instanceof KeyboardEvent) {
        const {altKey, shiftKey} = $event;
        if (altKey || shiftKey) return;
        $event.preventDefault();
      }

      const message = this.text.trim();
      if (message === "") return;
      const newMessage   = await Discussion.SendMessage(this.getDiscussion(), message);
      this.discussion_id = newMessage.discussion_id;
      this.addMessagesBottom({...newMessage, loc: true})
      this.text  = "";
      this.lines = 1;
    },
    processAudio(blob) {

      // this.addMessagesBottom({
      //   message: window.URL.createObjectURL(blob),
      //   type   : 1,
      //   loc    : true,
      // })
      Discussion.SendMessage(this.getDiscussion(), blob, 1).then((data) => {
        this.addMessagesBottom({...data, loc: true})
      })
    },
    async load(refresh = false, top = false) {
      const {count}     = this;
      const addMessages = top ? this.addMessageTop : this.addMessagesBottom;
      const id          = await this.getDiscussion();
      const {messages}  = await Discussion.GetMessages(id, {
        status: refresh ? 'unseen' : null,
        limit : count,
        offset: top ? count : null,
      });
      if (!messages || !messages.length) return 0
      addMessages(...messages.reverse())
      const idsToUpdate = messages.filter(m => m.status === "unseen").map(m => m.id);
      if (idsToUpdate.length) Discussion.UpdateStatus(idsToUpdate);
      return messages.length;
    },
    getDiscussion() {
      return this.discussion_id;
    },
    addMessageTop(...messages) {
      if (!messages.length) return;
      this.messages.unshift(...messages);
    },
    addMessagesBottom(...messages) {
      if (!messages.length) return;
      this.messages.push(...messages);
      this.updateScroll = true;
    },
    // display
    spyScroll(ev) {
      const t                                       = ev.target
      const {scrollTop, offsetHeight, scrollHeight} = t;
      this.lockScroll                               = scrollTop + offsetHeight === scrollHeight
      if (scrollTop === 0 && !this.loadedAll) {
        this.load(false, true).then(l => {
          this.loadedAll = l < this.count;
          this.$nextTick(() => {
            t.scrollTop = t.scrollHeight - scrollHeight;
          })
        });
      }
    },
    scrollToEnd(...refs) {
      if (refs.length === 0) refs = [this.$refs.chatBody]
      refs.forEach(ref => {
        if (!ref) return
        ref.scrollTop = ref.scrollHeight;
      });
    },
  },
  created() {
    this.discussion_id = this.discussion;
    this.timeOutID     = setInterval(() => {
      this.load(true);
    }, timeout)
    this.load().then((l) => {
      this.loadedAll = l < this.count
      this.$nextTick(() => {
        this.scrollToEnd();
      })
    });
  },
  updated() {
    if (this.lockScroll) {
      this.scrollToEnd();
      this.updateScroll = false;
    }
  },
  beforeDestroy() {
    clearInterval(this.timeOutID)
  }
}
</script>

<style scoped>
.chat-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  max-height: 100%;
}

.chat-body {
  overflow: auto;
  margin: 0 0.5rem;
}

.chat-footer {
  display: flex;
  align-items: center;
  margin: 0 0.5rem;
}

.chat-msg {
  border-radius: 1.3rem;
  padding: 4px 17px 9px;
  max-width: 60%;
  margin-bottom: 2px;
  white-space: pre-line;
}

.bg-gray {
  background-color: #f1f0f0;
}

.f-r {
  float: right;
  clear: right;
}

.f-l {
  float: left;
  clear: left;
}

audio {
  height: 37px;
  margin-bottom: 2px;
  outline: 0;
}

textarea {
  resize: none;
  margin-right: 1rem;
  height: calc(7.5rem + 0.75rem + 2px);
}

button {
  height: 46px;
  width: 46px;
}
</style>